import React from 'react';
import styles from '../DailyTrainingPage.module.css';

/**
 * EmptyState component for DailyTrainingPage
 * 
 * Displays a message when there are no items due for review.
 */
const EmptyState: React.FC = () => (
  <div className={styles.emptyState}>No items due for review today. Great job!</div>
);

export default React.memo(EmptyState); 